import { urls } from "../constants";
import api from "./api";

const getOrders = async ({ laboratoryId, page, limit, text }) => {
  try {
    const response = await api.get(urls.getOrders, {
      params: {
        laboratoryId,
        page,
        limit,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateOrder = async ({
  doctorId,
  productId,
  orderId,
  quantity,
}) => {
  try {
    const response = await api.put(`${urls.updateOrder}/${orderId}`, {
      doctorId,
      productId,
      quantity,
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const rejectOrder = async ({ orderId }) => {
  try {
    const response = await api.put(`${urls.updateOrder}/${orderId}`, null, {
      params: { status: 2 }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAllOrdersStatus = async () => {
  try {
    const response = await api.get(urls.getOrderStatus);
    return {
      status: response.status,
      data: response.data.result,
    };
  } catch (error) {
    console.error("Error al obtener los estados de las ordenes:", error);
    // throw error; // Previous logic re-threw error, keeping it consistent or catching it? 
    // The previous code returned a structured object if OK, but threw if not. 
    // Axios throws on error statuses.
    // The previous code had a specific try/catch block with console.error.
    // I will return the error structure to be consistent with other services refactored, 
    // BUT the original code threw the error. I should probably respect that if it's expected by the caller.
    // However, most other services in this app return { status, response } structure even on error.
    // This file seems to start mixing patterns (getAllOrdersStatus vs getOrders).
    // I will stick to returning the error object to avoid breaking if the UI expects it, 
    // OR re-throw if that's what the component expects.
    // Looking at line 84 of original: throw error;
    throw error;
  }
};

const updateOrderStatus = async ({ orderId, statusId, orderCode, inDeliveryComments }) => {
  try {
    const response = await api.put(`${urls.updateOrderStatus}/${orderId}`, {
      statusId,
      orderCode,
      inDeliveryComments
    });

    return {
      status: response.status,
      data: response.data.result,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error al actualizar los estados de las ordenes:", error);
    throw error;
  }
};

const orderServices = Object.freeze({
  getOrders,
  updateOrder,
  rejectOrder,
  getAllOrdersStatus,
  updateOrderStatus,
});

export default orderServices;
